import { debounce } from 'lodash-es';
import { toast } from 'vue-sonner';
import type { ExternalToast } from 'vue-sonner';

const DEBOUNCE_TIME = 1000;
const DEBOUNCE_DEFAULT_OPTIONS = { leading: true, trailing: false };

class MessagesHelper implements Alerts
{
    private toast: typeof toast;

    public constructor(instance: typeof toast)
    {
        this.toast = instance;
    }

    public close()
    {
        this.toast.dismiss();
    }

    // --------------------------------------------------

    public success(message: string, options: ExternalToast = {})
    {
        this.toast.success(message, options);
    }

    public debounceSuccess = debounce((message: string, options: ExternalToast = {}) =>
    {
        this.success(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    // --------------------------------------------------

    public info(message: string, options: ExternalToast = {})
    {
        this.toast.info(message, options);
    }

    public debounceInfo = debounce((message: string, options: ExternalToast = {}) =>
    {
        this.info(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    // --------------------------------------------------

    public warning(message: string, options: ExternalToast = {})
    {
        this.toast.warning(message, options);
    }

    public debounceWarning = debounce((message: string, options: ExternalToast = {}) =>
    {
        this.warning(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    // --------------------------------------------------

    public danger(message: string, options: ExternalToast = {})
    {
        this.toast.error(message, options);
    }

    public debounceDanger = debounce((message: string, options: ExternalToast = {}) =>
    {
        this.danger(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    // --------------------------------------------------

    public error(message: string, options: ExternalToast = {})
    {
        this.toast.error(message, options);
    }

    public debounceError = debounce((message: string, options: ExternalToast = {}) =>
    {
        this.error(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);
}

export default defineNuxtPlugin({
    name: 'alerts',
    dependsOn: [],
    async setup(nuxtApp)
    {
        return {
            provide: {
                alert: new MessagesHelper(toast)
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $alert: Alerts;
    }
}
